import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const About = () => {
  return (
    <section id="about" className="section-spacing about-section">
      <Container>
        <Row className="g-5 align-items-center">
          <Col lg={6}>
            <div className="about-image-frame">
              <img
                loading="lazy"
                src="/Images/about-image.webp"
                alt="SUPPoland rope access technician"
                className="img-fluid about-image"
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="about-content-panel">
              <p className="section-kicker">About</p>
              <h2 className="section-title">About SUPPoland</h2>
              <p className="lead section-lead">
                SUPPoland provides specialist rope access and work-at-height
                support for industrial, construction, and technical projects
                across Europe.
              </p>
              <p>
                The brand is built around practical project-site experience,
                IRATA Level 2 rope access qualification, and cooperation with
                contractors, subcontractors, and project teams that need reliable
                technical support at height.
              </p>
              <p className="mb-0">
                SUPPoland is presented as a specialist contractor available for
                project-based cooperation, not as a large agency or general rope
                access operator.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;